var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubregionsArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1767 10.2803C11.1298 10.3272 11.0662 10.3535 10.9999 10.3535C10.9336 10.3535 10.8701 10.3272 10.8232 10.2803L7.99993 7.45707L5.17668 10.2803C5.1298 10.3272 5.06622 10.3535 4.99993 10.3535C4.93364 10.3535 4.87006 10.3272 4.82318 10.2803L4.46968 9.92682C4.42281 9.87994 4.39648 9.81636 4.39648 9.75007C4.39648 9.68378 4.42281 9.6202 4.46968 9.57332L7.82318 6.21982C7.87006 6.17295 7.93364 6.14662 7.99993 6.14662C8.06622 6.14662 8.1298 6.17295 8.17668 6.21982L11.5302 9.57332C11.577 9.6202 11.6034 9.68378 11.6034 9.75007C11.6034 9.81636 11.577 9.87994 11.5302 9.92682L11.1767 10.2803Z",
    fill: "#1E2DBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubregionsArrow);
export default __webpack_public_path__ + "static/media/subregionsArrow.bf6423b66e0daaf0dfbbf6b058335c66.svg";
export { ForwardRef as ReactComponent };